import type { HTMLAttributes, ReactNode } from "react";
import styles from "./BottomNavigation.module.css";
import { cx } from "../cx";

export type BottomNavigationItem<K extends string = string> = {
  key: K;
  label: ReactNode;
  icon: ReactNode;
  /** 선택 상태 아이콘(없으면 icon 재사용). */
  selectedIcon?: ReactNode;
};

export type BottomNavigationProps<K extends string = string> = Omit<HTMLAttributes<HTMLElement>, "onChange"> & {
  items: BottomNavigationItem<K>[];
  value: K;
  onChange: (key: K) => void;
};

/** 하단 탭(홈·대화·마이페이지). expanded에서도 레일 없이 같은 모양. */
export function BottomNavigation<K extends string>({ items, value, onChange, className, ...rest }: BottomNavigationProps<K>) {
  return (
    <nav className={cx(styles.root, className)} {...rest}>
      {items.map((item) => {
        const selected = item.key === value;
        return (
          <button
            key={item.key}
            type="button"
            className={cx(styles.item, selected && styles.selected)}
            aria-current={selected ? "page" : undefined}
            onClick={() => onChange(item.key)}
          >
            <span className={styles.icon}>{selected ? (item.selectedIcon ?? item.icon) : item.icon}</span>
            <span className={styles.label}>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
